import React from 'react';
import get from 'lodash.get';

import { emptyObject } from 'ui-components/default-props/empty';
import { BulkActions } from '../../../enums/bulk-actions';
import { BulkEditOtherShippingOptionsContainer } from '../../../containers/bulk-update/bulk-edit-other-shipping-options-container';

export default {
  id: BulkActions.otherShippingOptions.name,
  render: (onChange, model, jobData) => {
    const shippingConfiguration = get(model, 'shippingConfiguration', emptyObject);
    const { services } = jobData;

    const onContainerChange = (options) => {
      onChange({
        ...model,
        shippingConfiguration: {
          ...shippingConfiguration,
          options,
        },
      });
    };

    return (
      <BulkEditOtherShippingOptionsContainer
        onChange={onContainerChange}
        services={services}
        shippingConfiguration={shippingConfiguration}
      />
    );
  },
};
